import React, { useEffect, useState } from "react";
import axios from "axios";

import { useParams } from "react-router-dom";

interface Slot {
  slot_no: number;
  time: string | null;
  value: number | null;
  is_active: boolean;
}

const SOCKET_URL = 'https://rek-hybrid.co.kr';
//const MonthConfig: React.FC<{ siteId: number; groupId: number; month: number }> = ({ siteId, groupId, month }) => {
const MonthConfig: React.FC = () => {

  const [slots, setSlots] = useState<Slot[]>([]);
  const currentMonth = new Date().getMonth() + 1; // 1~12
  const [activeMonth, setActiveMonth] = useState(currentMonth);

  const siteId = 1;
  const groupId = 101;


//   useEffect(() => {
//     // API에서 데이터 가져오기
//     axios
//       .get(`/api/config/${siteId}/${groupId}/${month}`)
//       .then((res) => {
//         // 항상 10개 슬롯으로 패딩
//         const data: Slot[] = res.data;
//         const padded = Array.from({ length: 10 }, (_, i) => {
//           const existing = data.find((d) => d.slot_no === i + 1);
//           return (
//             existing || { slot_no: i + 1, time: null, value: null, is_active: false }
//           );
//         });
//         setSlots(padded);
//       });
//   }, [siteId, groupId, month]);


    const handleGetMonth = async (month: number) => {
        setActiveMonth(month);
        try {
            const res = await axios.get(`${SOCKET_URL}/api/config/${siteId}/${groupId}/${month}`);
            const data: Slot[] = res.data;

            // 항상 10개 슬롯으로 패딩
            const padded = Array.from({ length: 10 }, (_, i) => {
                const existing = data.find((d) => d.slot_no === i + 1);
                return (
                existing || {
                    slot_no: i + 1,
                    time: null,
                    value: null,
                    is_active: false,
                }
                );
            });

            setSlots(padded);
        } catch (err) {
            console.error("월별 데이터 가져오기 실패:", err);
        }
    };

    const handleChange = (i: number, field: "time" | "value" | "is_active", value: any) => {
        const updated = [...slots];
        (updated[i] as any)[field] = value;
        if (field === "time" || field === "value") {
        updated[i].is_active = true; // 값 입력 시 자동 활성화
        }
        setSlots(updated);
    };

    const handleSave = async (month: number) => {
        try{
            await axios.put(`${SOCKET_URL}/api/config/${siteId}/${groupId}/${month}`, { slots });
            alert("저장 완료");
        } catch(err) {
            console.error("저장 실패:", err);
        }
    };

  return (
    <div>
      {/* 월별 탭 */}
      <div className="tabs">
        {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
          <button
            key={m}
            onClick={() => handleGetMonth(m)}
            className={activeMonth === m ? "active" : ""}
          >
            {m}월
          </button>
        ))}
      </div>

      {slots.map((slot, i) => (
        <div key={slot.slot_no} className="flex gap-2 mb-2">
          <input
            type="time"
            value={slot.time ?? ""}
            onChange={(e) => handleChange(i, "time", e.target.value)}
          />
          <input
            type="number"
            placeholder="값"
            value={slot.value ?? ""}
            onChange={(e) => handleChange(i, "value", Number(e.target.value))}
          />
          <label>
            <input
              type="checkbox"
              checked={slot.is_active}
              onChange={(e) => handleChange(i, "is_active", e.target.checked)}
            />
            사용
          </label>
        </div>
      ))}
      <button onClick={() => handleSave(activeMonth)}>저장</button>
    </div>
  );
};

export default MonthConfig;
